import { ConfirmationModal } from "src/base-components/ConfirmationModal";

type Props = {
  isActive: boolean;
  isOpen: boolean;
  closeModal: () => void;
  onConfirm: () => void;
};
export const QueryToggleConfirmationModal = ({
  isActive,
  isOpen,
  closeModal,
  onConfirm,
}: Props) => {
  return (
    <ConfirmationModal
      confirmationButtonText={isActive ? "Deactivate" : "Activate"}
      description={
        isActive
          ? "Deactivating this feature query will halt all associated feature value computations. This may affect published flows that rely on these feature values for their logic."
          : "Once you activate, you will not be able to edit the query nor its associated features. Are you sure you want to activate this query?"
      }
      open={isOpen}
      title={isActive ? "Deactivate query" : "Activate query"}
      variant={isActive ? "danger" : "default"}
      onClose={closeModal}
      onConfirm={onConfirm}
    />
  );
};
